import PropTypes from 'prop-types';
import React from 'react';
import './ChatbotResizeHandle.scss';

const ChatbotResizeHandle = ({ onResize, isResizing }) => {
  const handleMouseDown = (e) => {
    e.preventDefault();
    onResize(e);
  };

  return (
    <div
      className={`chatbot-resize-handle ${isResizing ? 'chatbot-resize-handle--active' : ''}`}
      onMouseDown={handleMouseDown}
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize chat panel"
      tabIndex={0}
    >
      <div className="chatbot-resize-handle__grip">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

ChatbotResizeHandle.propTypes = {
  onResize: PropTypes.func.isRequired,
  isResizing: PropTypes.bool,
};

ChatbotResizeHandle.defaultProps = {
  isResizing: false,
};

export default ChatbotResizeHandle;
